<!-- @format -->

<template>
  <b-card>
    <!-- form -->
    <b-form>
      <b-row>
        <!-- old password -->
        <b-col md="6">
          <b-form-group label="旧密码" label-for="account-old-password">
            <b-input-group class="input-group-merge">
              <b-form-input id="account-old-password" v-model="passwordValueOld" name="old-password" :type="passwordFieldTypeOld" placeholder="请输入旧密码" />
              <b-input-group-append is-text>
                <feather-icon :icon="passwordToggleIconOld" class="cursor-pointer" @click="togglePasswordOld" />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <!--/ old password -->
      </b-row>
      <b-row>
        <!-- new password -->
        <b-col md="5">
          <b-form-group label-for="account-new-password" label="新密码">
            <b-input-group class="input-group-merge">
              <b-form-input id="account-new-password" v-model="newPasswordValue" :type="passwordFieldTypeNew" name="new-password" placeholder="请输入新密码" />
              <b-input-group-append is-text>
                <feather-icon :icon="passwordToggleIconNew" class="cursor-pointer" @click="togglePasswordNew" />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="7">
          <b-form-group label-for="account-retype-new-password" label="再次输入新密码">
            <b-input-group class="input-group-merge">
              <b-form-input id="account-retype-new-password" v-model="RetypePassword" :type="passwordFieldTypeRetype" name="retype-password" placeholder="请再次输入新密码" />
              <b-input-group-append is-text>
                <feather-icon :icon="passwordToggleIconRetype" class="cursor-pointer" @click="togglePasswordRetype" />
              </b-input-group-append>
            </b-input-group>
            <div v-if="RetypePassword.length > 0">
              <span v-if="RetypePassword != newPasswordValue">新密码与再次输入的新密码不一致</span>
            </div>
          </b-form-group>
        </b-col>
        <b-col md="5">
          <b-form-group label-for="account-retype-new-password" label="邮箱">
            <b-input-group class="input-group-merge">
              <b-form-input v-model="email" disabled name="code" placeholder="请输入邮箱" />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="7">
          <b-form-group label-for="account-retype-new-password" label="邮箱验证">
            <b-input-group class="input-group-merge">
              <b-form-input v-model="code" name="code" placeholder="请输入邮箱验证码" />
              <b-input-group-append is-button>
                <b-button @click="sendCode" :disabled="sendCodeDisabled" variant="primary" size="sm" class="mr-2" ref="btnCode">发送验证码</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mt-1 mr-1" @click="changePassword" :disabled="isLoading"> 确认修改 </b-button>
          <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary" class="mt-1"> 重置表单 </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import { BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BInputGroup, BInputGroupAppend, BFormInvalidFeedback } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axiosIns from '@/libs/axios'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BInputGroup,
    BInputGroupAppend,
    BFormInvalidFeedback,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      code: '',
      passwordValueOld: '',
      newPasswordValue: '',
      RetypePassword: '',
      passwordFieldTypeOld: 'password',
      passwordFieldTypeNew: 'password',
      passwordFieldTypeRetype: 'password',
      isLoading: false,
      email: undefined,
      sendCodeDisabled: false,
      timer: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.email = JSON.parse(localStorage.getItem('userData')).email
    })
  },
  computed: {
    passwordToggleIconOld() {
      return this.passwordFieldTypeOld === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconNew() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordToggleIconRetype() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    // 倒计时 3分钟内只能发送一次验证码
    countDown() {
      const dom = this.$refs.btnCode
      let time = 3 * 60 * 1000
      this.sendCodeDisabled = true

      const timer = setInterval(() => {
        if (time > 0) {
          time -= 1000
          dom.innerText = `${Math.floor(time / 1000)}秒后重新发送`
        } else {
          clearInterval(timer)
          dom.innerText = '发送验证码'
          this.sendCodeDisabled = false
        }
      }, 1000)
      // this.sendCodeDisabled = true
      // this.timer = setInterval(() => {
      //   if (this.timer) {
      //     this.sendCodeDisabled = true
      //     this.timer = null
      //   }
      // }, 180000)
    },
    sendCode() {
      axiosIns
        .get('/login/sendEmailCode', {
          params: {
            email: this.email,
          },
        })
        .then(res => {
          if (res.code == 0) {
            this.sendCodeDisabled = true
            this.$bvToast.toast(res.msg, {
              autoHideDelay: 3000,
              appendToast: true,
              solid: true,
              toaster: 'b-toaster-top-center',
              variant: 'success',
            })
            this.countDown()
          } else {
            this.$bvToast.toast(res.msg, {
              autoHideDelay: 3000,
              appendToast: true,
              solid: true,
              toaster: 'b-toaster-top-center',
              variant: 'danger',
            })
          }
        })
    },
    togglePasswordOld() {
      this.passwordFieldTypeOld = this.passwordFieldTypeOld === 'password' ? 'text' : 'password'
    },
    togglePasswordNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype = this.passwordFieldTypeRetype === 'password' ? 'text' : 'password'
    },
    changePassword() {
      this.isLoading = true
      if (!this.passwordValueOld) {
        this.$bvToast.toast('请输入旧密码', {
          title: '提示',
          variant: 'warning',
          solid: true,
          appendToast: true,
          autoHideDelay: 2000,
        })
        this.isLoading = false
      } else {
        if (!this.newPasswordValue) {
          this.$bvToast.toast('请输入新密码', {
            title: '提示',
            variant: 'warning',
            solid: true,
            appendToast: true,
            autoHideDelay: 2000,
          })
          this.isLoading = false
        } else {
          if (this.RetypePassword != this.newPasswordValue) {
            this.$bvToast.toast('新密码与再次输入的新密码不一致', {
              title: '提示',
              variant: 'warning',
              solid: true,
              appendToast: true,
              autoHideDelay: 2000,
            })
            this.isLoading = false
          } else {
            axiosIns
              .post('/user/editPassword', {
                old_password: this.passwordValueOld,
                new_password: this.newPasswordValue,
                code: this.code,
              })
              .then(response => {
                if (response.code == 0) {
                  this.$bvToast.toast('修改成功', {
                    title: '提示',
                    variant: 'success',
                    solid: true,
                    appendToast: true,
                    autoHideDelay: 2000,
                  })
                  setTimeout(() => {
                    // this.$router.back()
                  }, 2000)
                } else {
                  this.$bvToast.toast(response.msg, {
                    title: '提示',
                    variant: 'warning',
                    solid: true,
                    appendToast: true,
                    autoHideDelay: 2000,
                  })
                  this.isLoading = false
                }
              })
              .catch(error => {
                this.$bvToast.toast(error.message, {
                  title: '提示',
                  variant: 'warning',
                  solid: true,
                  appendToast: true,
                  autoHideDelay: 2000,
                })
                this.isLoading = false
              })
          }
        }
      }
      console.log(this.passwordValueOld, this.newPasswordValue, this.RetypePassword)
    },
  },
}
</script>
